import React from "react";
import {
  Box,
  Heading,
  Text,
  Flex,
} from "@chakra-ui/core";

/** Feature section of the Landing page */

const Feature = ({ title, icon, children, ...props }) => {

    return (
        <Flex
        my=".5rem"
        d="flex"
        alignItems="stretch"
        >
          <Flex alignItems="center" >
              <Flex borderRadius="50%" borderWidth="1px" borderColor="primary.400" size="60px" align="center" justify="center">
                <Box as={icon} size="32px" color="primary.500"/>
              </Flex>
          </Flex>
          <Box pb="1rem" ml="10px">
              <Heading color="primary.500" as="h4" size="sm" fontWeight="semibold">
              {title}
              </Heading>
              <Text fontSize="sm" opacity="0.7">{children}</Text>
          </Box>
        </Flex>
    );
};

export default Feature;